import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import { setIsLoading } from 'reducers/partnerStatusReducer';
import { closeAllModals } from 'reducers/modalReducer';
import { selectPartnerId, selectPartnerStatusError } from 'selectors/partnerStatusSelector';
import { CreateAccessCodeActions } from 'views/MemberZoneAccess/CreateAccessCode/CreateAccessCodeActions';
import { CreateAccessCodeForm } from 'views/MemberZoneAccess/CreateAccessCode/CreateAccessCodeForm';
import { CreateAccessCodeFormSkeleton } from 'views/MemberZoneAccess/CreateAccessCode/CreateAccessCodeFormSkeleton';
import { CustomError } from 'types';
import { useErrorHandling } from 'components/hooks/useErrorHandling';
import { AppDispatch, RootState } from 'store';

export const CreateAccessCode = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const partnerNumber = useSelector(selectPartnerId);
  const error: CustomError | undefined = useSelector(selectPartnerStatusError);
  const isLoading = useSelector((state: RootState) => {
    return state.partner.isLoading;
  });

  useErrorHandling(error, () => {
    navigate(`/partner?partnerNumber=${partnerNumber}`);
    dispatch(setIsLoading(true));
    dispatch(closeAllModals());
  });

  return (
    <>
      <Grid style={{ paddingLeft: theme.spacing(4) }}>
        <Typography variant="h1">{`ACCESS TO 'FINANCIAL NEWS' ON JB MOBILE`}</Typography>
      </Grid>
      <Grid style={{ paddingLeft: theme.spacing(4) }}>
        {isLoading ? <CreateAccessCodeFormSkeleton /> : <CreateAccessCodeForm />}
      </Grid>
      <CreateAccessCodeActions />
    </>
  );
};
